module.exports = __webpack_public_path__ + "static/img/bz2.86109ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/bz2.png
// module id = 305
// module chunks = 0